import React from 'react'
import { connect } from 'react-redux'
import NarrowLayoutContainer from './NarrowLayoutContainer'
import WideLayout from './WideLayout'
import * as layouts from '../../constants/layouts'

const mapStateToProps = (state) => ({
	layoutIsNarrow: state.layout === layouts.NARROW
})

const Layout = ({ layoutIsNarrow }) => layoutIsNarrow ? <NarrowLayoutContainer /> : <WideLayout />

export default connect(mapStateToProps)(Layout);



// WEBPACK FOOTER //
// ./src/components/Layout/LayoutContainer.js